import React, { createContext, useEffect, useMemo, useState } from "react";
import App from "./App";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { injected, chainData } from "./connector/Connecter";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import copy from "copy-to-clipboard";
import Web3 from "web3";
import "./OnmaxContext.css";

export const OnmaxContext = createContext();

function Onmaxcontext() {
  var { active, activate, deactivate, error, library } = useWeb3React();
  // account = "testing1";
  const account = localStorage.getItem("username");
  const [balance, setBalance] = useState(0);
  const [DBbalance, setDBBalance] = useState(0);
  const [settings, setsettings] = useState([]);
  const [userdata, setuserdata] = useState([]);
  const [rate, setrate] = useState(0);
  const [web3, setWeb3] = useState(null);
  const [tokenrate, settokenrate] = useState(0);
  const [blocks, setblocks] = useState(null);
  const [smuser, setsmuser] = useState(null);
  const [dbuser, setdbuser] = useState(null);
  const [stakcontract, setstakcontract] = useState(null);

  const [profile, setprofile] = useState(null);
  const getprofileData = async () => {
    if (!account) return;
// console.log('account',account);
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        username:account,
        key: process.env.REACT_APP_KEY,
      });
// console.log('res',res);
      if (res.data?.error || !res.data?.data) {
        setprofile(null);
      } else {
        // console.log(
        //   'setprofile',res.data.data
        // );
        setprofile(res.data.data);
      }
    } catch (error) {
      console.error("Profile fetch error:", error);
      setprofile(null);
    }
  };
  useEffect(() => {
    getprofileData()
  }, [account]);

  const formatAddress = (address) => {
    if (address) {
      return address.substr(0, 6) + "..." + address.substr(-6, 6);
    }
  };
  const connectInjected = async () => {
    try {
      await activate(injected);
    } catch (ex) {
      console.log(ex);
    }
  };
  const toastError = (data) => {
    toast.error(data);
  };
  const toastSuccess = (data) => {
    toast.success(data);
  };
  const toastInfo = (data) => {
    toast(data, {
      // Custom Icon
      icon: "❕",
      // Aria
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    });
  };
  const addchain = async () => {
    toastError("Connect wtih BSC Mainnet");
    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: chainData,
    });
  };
  const copyaddress = (address) => {
    copy(address);
    toastSuccess("Copied");
  };

  const getSetting = async () => {
    // console.log("link :- ", process.env.REACT_APP_BACKEND_LINK, process.env.REACT_APP_KEY);
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "setting",
        submethod: "get",
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        // console.log('setting', res.data.data);

        // var dedata = decryptData(res.data);
        if (res.data.error) {
          return "";
        }
        setsettings(res.data.data);
      });
  };

  async function disconnect() {
    try {
      deactivate();
      localStorage.setItem("isconnected", false);
      setBalance(0);
    } catch (ex) {
      console.log(ex);
    }
  }

  const connectMetamask = async () => {
    try {
      await activate(injected);

      localStorage.setItem("isconnected", true);
    } catch (error) {
      alert(error);
    }
  };

  const getudata = async (account) => {
    return await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "user",
      submethod: "getbyid",
      username: account,
      key: process.env.REACT_APP_KEY,
    });
  };


  // const getudata = async (address) => {
  //   return await axios.post(`${process.env.REACT_APP_BACKEND_LINK}`, {
  //     method: "user",
  //     submethod: "getbyid",
  //     key: process.env.REACT_APP_KEY,
  //     username: address ? address.toLowerCase() : address,
  //   });
  // };
  const [loading, setLoading] = useState(true);
  const getuserDB = async () => {
    try {
      setLoading(true); // ✅ start loader

      const res = await getudata(account);
      const userData = res?.data?.data;

      if (res.data?.error || !userData) {
        setdbuser(null);
        return;
      }

      // ✅ set user data
      setdbuser(userData);

      // ✅ set balance safely
      const balance = Number(userData.balance || 0);
      setDBBalance(balance.toFixed(2));

    } catch (error) {
      console.error("getuserDB error:", error);
      setdbuser(null);
    } finally {
      setLoading(false); // ✅ stop loader
    }
  };
  useEffect(() => {
    if (account) {
      getuserDB();
    }
  }, [account]);

  useEffect(() => {
    if (localStorage.getItem("isconnected") === "true") {
      connectMetamask();
    }
    getSetting();
  }, []);

  useEffect(() => {
    setWeb3(new Web3(process.env.REACT_APP_RPC));
    // setWeb3(new Web3("https://bsc-dataseed.binance.org"));
  }, [chainData]);
  useEffect(() => {
    if (error instanceof UnsupportedChainIdError) {
      console.log("error", error);
      addchain();
    }
  }, [error]);

  const getsmcs = async () => {
    // console.log("account ", account);
    if (!library || !settings.token) {
      return;
    }
    var b = await library.eth.getBalance(account);
    // console.log("b is..", b)

    let contract = new library.eth.Contract(
      JSON.parse(settings.token_abi),
      settings.token
    );
    let maincontract = new library.eth.Contract(
      JSON.parse(settings.contract_abi),
      settings.contract
    );
    setstakcontract(maincontract);
    var balance = await contract.methods.balanceOf(account).call();
    var getrate = await maincontract.methods.maticrate().call();
    var gettokenrate = await maincontract.methods.tokenrate().call();
    var minstakeblocka = await maincontract.methods.minstakeblocka().call();
    var maxstakeblocka = await maincontract.methods.maxstakeblocka().call();
    var minstakeblockb = await maincontract.methods.minstakeblockb().call();
    var maxstakeblockb = await maincontract.methods.maxstakeblockb().call();
    var blockss = {
      minstakeblocka: Number(library.utils.fromWei(minstakeblocka, "ether")),
      maxstakeblocka: Number(library.utils.fromWei(maxstakeblocka, "ether")),
      minstakeblockb: Number(library.utils.fromWei(minstakeblockb, "ether")),
      maxstakeblockb: Number(library.utils.fromWei(maxstakeblockb, "ether")),
    };
    setblocks(blockss);
    var user = await maincontract.methods.user(account).call();
    setsmuser({
      referral: user._ref,
      mem: user._mem,
      contractaddress: user._contractaddress,
    });
    console.log("getrate", blocks, getrate, user);

    setrate(Number(library.utils.fromWei(getrate, "ether")).toFixed(2));
    settokenrate(
      Number(library.utils.fromWei(gettokenrate, "ether")).toFixed(2)
    );

    setBalance(Number(library.utils.fromWei(balance, "ether")).toFixed(2));

    return { balance: b };
  };
  useEffect(() => {
    getsmcs();
  }, [account, library, settings]);

  function formatDateTime(date) {
    const datetime = new Date(date);
    const day = String(datetime.getDate()).padStart(2, "0");
    const month = String(datetime.getMonth() + 1).padStart(2, "0");
    const year = datetime.getFullYear();
    const hours = String(datetime.getHours()).padStart(2, "0");
    const minutes = String(datetime.getMinutes()).padStart(2, "0");
    const seconds = String(datetime.getSeconds()).padStart(2, "0");

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  }

  const contextValue = useMemo(
    () => ({
      settings: settings,
      library,
      balance,
      userdata,
      dbuser,
      loading,
      getuserDB,
      formatDateTime,
      active,
      web3,
      blocks,
      tokenrate,
      smuser,
      account: account ? account.toLowerCase() : account,
      connectInjected,
      disconnect,
      connectMetamask,
      formatAddress,
      toastError,
      toastSuccess,
      getudata,
      toastInfo,
      getsmcs,
      rate,
      copyaddress,
      stakcontract,
      DBbalance,
      profile,
    }),
    [
      settings,
      library,
      balance,
      userdata,
      dbuser,
      loading,
      account,
      active,
      web3,
      blocks,
      tokenrate,
      smuser,
      rate,
      stakcontract,
      DBbalance,
      profile,
    ]
  );

  return (
    <>
      {/* Custom Styles for AI Alerts */}
         <style>
        {`
          @keyframes ai-enter {
            0% { 
              transform: translateY(-20px) scale(0.9); 
              opacity: 0; 
            }
            100% { 
              transform: translateY(0) scale(1); 
              opacity: 1; 
            }
          }

          @keyframes ai-pulse {
            0% { 
              box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.1); 
            }
            70% { 
              box-shadow: 0 0 20px 10px rgba(255, 255, 255, 0); 
            }
            100% { 
              box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); 
            }
          }
        
          .ai-toast-success {
            background: linear-gradient(135deg, #064e3b 0%, #022c22 100%) !important;
            border: 1px solid #10b981 !important;
            color: #fff !important;
            box-shadow: 0 10px 30px -5px rgba(16, 185, 129, 0.3) !important;
            animation: ai-enter 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards, ai-pulse 2s infinite;
          }
        
          .ai-toast-error {
            background: linear-gradient(135deg, #7f1d1d 0%, #450a0a 100%) !important;
            border: 1px solid #ef4444 !important;
            color: #fff !important;
            box-shadow: 0 10px 30px -5px rgba(239, 68, 68, 0.3) !important;
            animation: ai-enter 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards, ai-pulse 2s infinite;
          }
        
          .ai-toast-base {
            border-radius: 12px !important;
            padding: 16px 20px !important;
            font-weight: 600 !important;
            font-size: 15px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
        `}
      </style>

      <Toaster
        position="top-center"
        toastOptions={{
          className: 'ai-toast-base',
          duration: 4000,
          style: {
            background: '#0f172a',
            color: '#fff',
            border: '1px solid #334155'
          },
          success: {
            className: 'ai-toast-base ai-toast-success',
            style: {}, // Override default properties with class
            iconTheme: { primary: '#fff', secondary: '#10b981' }
          },
          error: {
            className: 'ai-toast-base ai-toast-error',
            style: {},
            iconTheme: { primary: '#fff', secondary: '#ef4444' }
          }
        }}
      />
      <OnmaxContext.Provider value={contextValue}>
        <App />
      </OnmaxContext.Provider>
    </>
  );
}

export default Onmaxcontext;
